import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  Tooltip,
} from '@mui/material';
import { ReactNode, FC, ComponentType } from 'react';

export interface TooltipButtonProps extends MuiButtonProps {
  tooltip?: ReactNode;
  ButtonComponent?: ComponentType<MuiButtonProps>;
}

const TooltipButton: FC<TooltipButtonProps> = ({
  tooltip,
  disabled,
  children,
  ButtonComponent = MuiButton,
  ...props
}) => {
  const button = (
    <ButtonComponent {...props} disabled={disabled}>
      {children}
    </ButtonComponent>
  );

  return tooltip ? (
    <Tooltip arrow title={tooltip}>
      <span style={{ display: 'block', width: 'fit-content' }}>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

export default TooltipButton;
